import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-money-log-link'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  'Authorization': token
})

export const getMoneyLogMismatches = async (token, filter = {}) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/mismatches`, filter, {
    headers: headers(token),
  })
  if (response && response.status === 200) {
    return response.data || { total: 0, data: [] }
  }
  return { total: 0, data: [] }
}

export const lookupMoneyLog = async (token, id) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/lookup`, { id }, {
    headers: headers(token),
  })
  if (response && response.status === 200) {
    return response.data || { logs: [], documents: [] }
  }
  return { logs: [], documents: [] }
}
